import type { SessionApiUpdateQuery } from "@/Modules/Models/Api/ClinicalHistory";
import type { SessionUpdateQuery } from "@/Modules/Models/Domain/ClinicalHistory";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { updateSession } from "@/Services/TherapyApi/ClinicalHistory";
import SessionTransformer, {
  type SessionTransformerType,
} from "@/Modules/Transformers/ClinicalHistory/Session";

import useClinicalHistoryStore from "@/Modules/ClinicalHistory/Store";
import useAppStore from "@/Modules/App/Store";
import useCustomerStore from "@/Modules/Customers/Store";

import { hasValue } from "@/Utils/Objects";
import { snake } from "@/Utils/Snakelize";

async function updateSessionAH(sessionId: string, sessionData: SessionUpdateQuery): Promise<boolean> {
  const appStore = useAppStore();
  const clinicalHistoryStore = useClinicalHistoryStore();
  const customerStore = useCustomerStore();

  if (!hasValue(customerStore.getCurrentCustomer)) return false;

  clinicalHistoryStore.isLoadingSession = true;

  try {
    const apiQuery = snake<SessionUpdateQuery, SessionApiUpdateQuery>(sessionData);
    const sessionApi = await updateSession(customerStore.getCurrentCustomer.id, sessionId, apiQuery);
    const sessionTransformer: SessionTransformerType = SessionTransformer;
    const sessionDomain = sessionTransformer.toDomain(sessionApi);

    clinicalHistoryStore.session = sessionDomain;

    appStore.showSnackbar({
      type: NotificationType.SUCCESS,
      message: "user.settings.customer.clinical_history.history_sessions.saved_notification",
    });

    return true;
  } catch (err: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });

    return false;
  } finally {
    clinicalHistoryStore.isLoadingSession = false;
  }
}

export default updateSessionAH;
